// extracted by mini-css-extract-plugin
module.exports = {"imageContainerGrid":"RecipeBlock_imageContainerGrid__Xg3cb","imageContainer":"RecipeBlock_imageContainer__Lvh3M"};